<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
    <NavBar v-if="showNavbar" />
    <div class="middle-container">
      <div v-if="ifShowMenu" class="sidebar-container">
        <sidebar />
        <div v-if="status !== 'approved'" :class="[status, 'disabledSidebar']" @click="showCertifyModel"></div>
      </div>
      <div :class="[ifShowMenu ? 'setMargin' : 'middle', 'main-container']">
        <breadcrumb class="breadcrumb-container" />
        <app-main />
        <Footer />
      </div>
    </div>
    <NotCertified :showNotCertifi="showNotCertifi" @closeModel="closeModel" />
  </div>
</template>

<script>
import { Sidebar, AppMain, NavBar } from './components'
import NotCertified from '@/components/NotCertifiedModel'
import Footer from '@/components/Footer'
import ResizeMixin from './mixin/ResizeHandler'
import Breadcrumb from '@/components/Breadcrumb'
import { mapState } from 'vuex'
import { getToken } from '@/utils/auth'
export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain,
    NavBar,
    NotCertified,
    Breadcrumb,
    Footer
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      ifShowMenu: state => state.app.ifShowMenu,
      device: state => state.app.device,
      fixedHeader: state => state.settings.fixedHeader,
      status: state => state.user.status
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        // mobile: this.device === 'mobile'
      }
    }
  },
  data() {
    return {
      showNotCertifi: false,
      showNavbar: false
    }
  },
  created() {
    if (getToken()) {
      this.showNavbar = true
    }
  },
  methods: {
    handleClickOutside() {
      // this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    showCertifyModel() {
      this.showNotCertifi = true
    },
    closeModel() {
      this.showNotCertifi = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    .middle-container {
      background: #f3f4f6;
      display: flex;
      padding-top: $navBarHeight;
      // min-width: 1300px;
      .main-container {
        &.middle {
          margin: 0 auto;
        }
      }
    }
    @include clearfix;
    position: relative;
    min-height: calc(100vh - #{$navBarHeight});
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
